import { PollAnswerAreaContent } from '@lessonup/pin-renderer';
import { PollTeacherPin } from '@lessonup/pins-shared';
import React from 'react';
import { PollPinTextAnswerArea } from './PollPin/PollPinTextAnswerArea';

export interface PollAnswerAreaContentEditorProps {
  pin: PollTeacherPin;
  isInteractive?: boolean;
}

export const PollAnswerAreaContentEditor: React.FC<PollAnswerAreaContentEditorProps> = ({
  pin,
  isInteractive = false,
}) => {
  switch (pin.settings.type) {
    case 'TEXT':
      return <PollPinTextAnswerArea pinId={pin.id} pinSettings={pin.settings} isInteractive={isInteractive} />;
    default:
      return <PollAnswerAreaContent pinSettings={pin.settings} isInteractive={false} />;
  }
};
